import { sellerApiClient } from "./sellerApiClient";
import {TokenResponse} from "@api/Responses/TokenResponse.ts";

export const impersonate = async (
  userName: string,
  password: string,
  sellerEmailOrPhone: string,
): Promise<TokenResponse> => {
  const response = await sellerApiClient.post<TokenResponse>(
    "/v1/auth/impersonate",
    {
      userName: userName,
      password: password,
      clientId: "sellers-dashboard-webui",
      sellerEmailOrPhone: sellerEmailOrPhone
    }
  );

  return response.data;
};
